export const HRRColor = [232, 104, 174];
export const HROColor = [250, 202, 38];
export const NoColor = [255, 255, 255];

export const HRR3DModel = '/HRR.gltf';
export const HRO3DModel = '/HEO.glb';
